export const tabs = {
    slots: {
        trigger: 'cursor-pointer',
    },
    variants: {
        orientation: {
            horizontal: {
                list: 'w-fit self-start',
            },
        },
    },
}
